import cn from "clsx";
import * as React from "react";
import { FaIcon } from "./faIcon.js";
import { InIcon } from "./inIcon.js";
const Icon = React.forwardRef(({ className, role = "icon", size, prefix = "inno", iconName, children, style, shape, ...props }, ref) => {
    return (React.createElement("span", { className: cn("in-icon", shape ? `in-icon--${size}--${shape}` : `in-icon--${size}`, className) }, prefix === "inno" ? (React.createElement(InIcon, { size: size, iconName: iconName })) : (React.createElement(FaIcon, { size: size, prefix: prefix, iconName: iconName }))));
});
Icon.displayName = "Icon";
export { Icon };
//# sourceMappingURL=icon.js.map